import { render, staticRenderFns } from "./ApplicationStart.vue?vue&type=template&id=2478acc0&"
import script from "./ApplicationStart.vue?vue&type=script&lang=js&"
export * from "./ApplicationStart.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2478acc0')) {
      api.createRecord('2478acc0', component.options)
    } else {
      api.reload('2478acc0', component.options)
    }
    module.hot.accept("./ApplicationStart.vue?vue&type=template&id=2478acc0&", function () {
      api.rerender('2478acc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/views/ApplicationStart.vue"
export default component.exports